<template>
  <dl :class="`${className} materialItem`">
    <dt class="materialItem_left">
      <el-image :src="require(`@/assets/img/mySciencePopularization/${info.type}.svg`)"></el-image>
    </dt>
    <dd class="materialItem_right">
      <slot name="listRight"></slot>
    </dd>
  </dl>
</template>
<script>
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    },
    width: {
      type: String,
      default: '100%'
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  methods: {

  },
  created () {
  }
}
</script>
<style lang="less" scoped>
.materialItem {
  position: relative;
  display: flex;
  justify-content: space-between;
  min-height: 180px;
  border-radius: 8px;
  margin: 0;
  padding: 20px;
  background-color: #fff;
  transition: top 0.3s;
  .materialItem_left {
    position: relative;
    width: 96px;
    display: flex;
    align-items: center;
    background: #F5F7FB;
    justify-content: center;
    border-radius: 8px;
  }

  .materialItem_right {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    width: calc(100% - 116px);
    height: 100%;
    gap: 2px;
    .right-title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all; //强制换行
      font-size: 16px;
      font-weight: 700;
      color: #4b639f;
    }
    .hand {
      padding-bottom: 8px;
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏溢出的部分 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
    .right-item {
      color: #606266;
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏溢出的部分 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
    .right-span {
      display: flex;
      gap: 40px;
    }
    .right-button{
      display: flex;
      align-items: center;
      gap: 20px;
      padding-top: 8px;
      span{
        color: #f56c6c;
      }
    }
    .tag {
      padding: 0 5px;
      border-right: 1px solid #ccc;
      &:last-child {
        padding-right: 0;
        border: 0;
      }
    }
  }
}
// 基础素材的样式
.materialItemSmall {
  justify-content: normal;
  gap: 12px;
  width: 315px;
  .materialItem_left {
    width: 86px;
    display: flex;
    align-items: center;
    background: #F5F7FB;
    justify-content: center;
    border-radius: 8px;
  }
  .materialItem_right {
    width: calc(100% - 86px);
    margin-left: 0;
    .right-button{
      .el-button--mini{
        padding: 5px 13px;
      }
    }
  }
}
</style>
